import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Slide from "@mui/material/Slide";
import { useSnapshot } from "./snapshot.context";

/** A Snapshot page's toasts (useSnapshot().notify), stacked bottom-right, each gone after a few seconds or when closed. */
export const SnapshotToasts = () => {
  const snapshot = useSnapshot();

  return (
    <Stack
      aria-live="polite"
      role="status"
      spacing={1}
      sx={{
        bottom: 24,
        maxWidth: "min(420px, calc(100vw - 32px))",
        position: "fixed",
        right: 24,
        zIndex: (theme) => theme.zIndex.snackbar,
      }}
    >
      {snapshot.toasts.map((toast) => (
        <Slide
          direction="up"
          in
          key={toast.id}
        >
          <Alert
            onClose={() => snapshot.dismissToast(toast.id)}
            severity={toast.severity}
            sx={{ boxShadow: 3 }}
            variant="filled"
          >
            {toast.message}
          </Alert>
        </Slide>
      ))}
    </Stack>
  );
};
